import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import ImageIcon from '@mui/icons-material/Image';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import LockIcon from '@mui/icons-material/Lock';
import Picker from 'emoji-picker-react';
import { withStyles } from '@mui/styles';
import React, { FC, useEffect, useRef, useState } from 'react';
import { IEmoji } from 'interfaces/emoji.interface';
import { uploadFileUtil } from 'utils/Fileupload.utils';
import ReplyToMessage from './ReplyToMessage';
import { useAppSelector } from 'app/hooks';
import {
  selectChat,
  updateLastMessageTime,
  updateReplyToMessage,
} from 'features/auth/chatSlice';
import { useDispatch } from 'react-redux';
import { handleSendMessage } from 'utils/Firebase.util';
import { selectAuth } from 'features/auth/authSlice';
import LockContentModal from 'components/molecules/LockContentModal';
import { IMessage } from 'interfaces/message.interface';
import ImagePreview from './ImagePreview';
import './styles.css';

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff',
      fontSize: '14px',
    },
  },
})(InputBase);

interface DMInputProps {
  user: any;
  mobile: boolean;
  messages?: IMessage[];
}

const DMInput: FC<DMInputProps> = ({ user, mobile, messages }) => {
  const [input, setInput] = useState<string>('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [media, setMedia] = useState<string | undefined>();
  const [premium, setPremium] = useState({
    isPremium: false,
    price: '0.00',
  });
  const [file, setFile] = useState<any>();
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  const emojiPickerRef = useRef<any>();
  const file_ref = useRef<any>();
  const dispatch = useDispatch();
  const onEmojiSelect = (e: React.MouseEvent, emojiObject: IEmoji) => {
    let symbol = emojiObject.unified.split('-');
    let codesArr: string[] = [];
    symbol.forEach(el => codesArr.push('0x' + el));
    let emoji = String.fromCodePoint(Number(...codesArr));
    setInput(input + emoji);
  };
  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (
        showEmojiPicker &&
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(e.target)
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener('click', checkIfClickedOutside);
    return () => {
      document.removeEventListener('click', checkIfClickedOutside);
    };
  }, [showEmojiPicker]);

  const pickerStyle = {
    position: 'absolute',
    bottom: '120%',
    right: '0%',
    display: showEmojiPicker ? '' : 'none',
  };

  //Check file mime types before upload

  const getMediaMessages = () => {
    const media = ['video', 'image', 'nft'];
    if (messages && authState.id) {
      return messages.filter(message => {
        return media.includes(message.type) && message.uid === authState.id;
      });
    }
  };

  const localHandleSendMessage = async (e: any) => {
    if (e.target.value && user) {
      if (e.target.type === 'text') {
        handleSendMessage(
          e.target.value,
          undefined,
          authState,
          mobile ? user.data : user,
          chatState,
          chatState.currentIndex
        );
        setInput('');
        dispatch(updateReplyToMessage({}));
      } else if (e.target.type === 'file') {
        const img = /image/;
        const video = /video/;
        const file = e.target.files[0];
        if (img.test(file.type)) {
          const imgUrl = await uploadFileUtil(e.target.files[0]);
          handleSendMessage(
            imgUrl,
            'image',
            authState,
            mobile ? user.data : user,
            chatState,
            chatState.currentIndex,
            premium.isPremium
          );
          dispatch(updateReplyToMessage({}));
        } else if (video.test(file.type)) {
          const imgUrl = await uploadFileUtil(e.target.files[0]);
          handleSendMessage(
            imgUrl,
            'video',
            authState,
            mobile ? user.data : user,
            chatState,
            chatState.currentIndex,
            premium.isPremium
          );
          dispatch(updateReplyToMessage({}));
        }
      }
    }
    dispatch(
      updateLastMessageTime({
        userId: mobile ? user.data.id : user.id,
        lastMessageTime: new Date().getTime(),
      })
    );
    setMedia(undefined);
  };

  const handleMediaUpload = (e: any) => {
    const url = URL.createObjectURL(e.target.files[0]);
    setMedia(url);
    setFile(e);
  };

  const handlePremium = (price: string) => {
    if (price !== '') {
      setPremium({ isPremium: true, price });
    } else {
      setPremium({ isPremium: false, price: '' });
    }
    // setFormData({ ...formData, ...premium });
  };

  return (
    <Box
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        // height: "100%",
        paddingX: '12px',
        paddingY: '10px',
        backgroundColor: 'rgba(150,143,206,0.22156862745098039 )',
        borderRadius: '15px',
        boxShadow: 'unset',
        boxSizing: 'border-box',
        position: 'relative',
      }}
      ref={emojiPickerRef}
    >
      {media && (
        <ImagePreview
          sendMessage={localHandleSendMessage}
          e={file}
          setMedia={setMedia}
          url={media}
        />
      )}
      <ReplyToMessage />
      <Box
        sx={{
          color: '#ffffff',
          borderRadius: '20px',
          borderColor: '#ffffff',
          borderStyle: 'solid',
          fontSize: '8px',
          padding: '3px',
          paddingRight: '6px',
          paddingLeft: '6px',
          borderWidth: '1px',
        }}
      >
        $ TIP
      </Box>
      <WhiteTextField
        sx={{ ml: 1, flex: 1, color: '#ffffff', fontSize: '14px' }}
        placeholder="Write a message..."
        inputProps={{ 'aria-label': 'Add a comment...' }}
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && localHandleSendMessage(e)}
      />
      <input
        ref={file_ref}
        onChange={(e: any) => handleMediaUpload(e)}
        style={{ display: 'none' }}
        type="file"
        id="file_input"
      />
      <IconButton
        sx={{ color: '#c1c1c1', paddingRight: '6px', marginTop: '5px' }}
        aria-label="lock"
      >
        <LockContentModal
          handlePremium={handlePremium}
          user={user}
          messages={getMediaMessages()}
        >
          <LockIcon />
        </LockContentModal>
      </IconButton>
      <IconButton
        sx={{ color: '#c1c1c1', paddingRight: '6px', paddingY: '5px' }}
        aria-label="comment"
        onClick={() => file_ref.current.click()}
      >
        <ImageIcon />
      </IconButton>
      <IconButton
        sx={{ color: '#c1c1c1', paddingRight: '0px', paddingY: '5px' }}
        aria-label="comment"
        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
      >
        <EmojiEmotionsIcon />
      </IconButton>
      <Picker
        pickerStyle={pickerStyle}
        disableAutoFocus
        onEmojiClick={onEmojiSelect}
      />
    </Box>
  );
};

export default DMInput;
